function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
import { CHECK_RECOVERY_CODE_VALIDITY_FETCH, SAVE_PASSWORD_FETCH, RECOVER_BY_EMAIL_FETCH, RECOVER_BY_PHONE_FETCH } from './constants';
import ApiErrorCode from '../enums/apiErrorCode';
import * as Actions from './actions';
import * as API from '../services/api';
var isRecoverTryValid = function isRecoverTryValid(body) {
  return body.attemptCount >= 0 && body.token;
};
var getError = function getError(body) {
  return body.errors && body.errors.length > 0 && body.errors[0].message || '';
};
/**
 * Handle response from API call
 * @param {Object} response response object from request
 * @param {Object} parsedBody parsed body from response
 * @param {Function} onSuccess 200 status code success callback
 * @param {Function} onError 400 | 404 | 500 status code error callback
 * @returns {Void} Nothing to return
 */

function handleResponse(response, parsedBody, onSuccess, onError) {
  switch (response.status) {
    case 200:
      // We accept only 200 code as success response, based on backend logic
      onSuccess(parsedBody);
      break;
    default:
      onError(parsedBody);
      break;
  }
}
/**
 * Handle recovery code check API call
 * @param {String} apiUrl API url
 * @param {String} token Token for API
 * @param {Function} dispatch Store actions handler
 * @param {String} recoveryCode Recovery code which need to check
 * @return {Void} Nothing to return
 */

function handleRecoveryCodeCheckFetch(_x, _x2, _x3, _x4) {
  return _handleRecoveryCodeCheckFetch.apply(this, arguments);
}
/**
 * Handle password saving API call
 * @param {String} apiUrl API url
 * @param {String} token Token for API
 * @param {Function} dispatch Store actions handler
 * @param {String} newPassword New passwod which need to save
 * @return {Void} Nothing to return
 */

function _handleRecoveryCodeCheckFetch() {
  _handleRecoveryCodeCheckFetch = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(apiUrl, token, dispatch, recoveryCode) {
    var _ref2, res, body;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return API.validateRecoveryCode(apiUrl, token, recoveryCode);
          case 3:
            _ref2 = _context.sent;
            res = _ref2.res;
            body = _ref2.body;
            handleResponse(res, body, function (body) {
              var isTryValid = isRecoverTryValid(body);
              if (isTryValid && body.token !== ApiErrorCode.NO_RECOVERY_FOUND) {
                dispatch(Actions.checkRecoveryCodeValiditySuccess(body.attemptCount, body.token));
              } else {
                dispatch(Actions.checkRecoveryCodeValidityError());
              }
            }, function (body) {
              var error = getError(body);
              if (error === ApiErrorCode.TOKEN_NOT_FOUND) {
                dispatch(Actions.checkRecoveryCodeValidityInvalidOrExpired());
              } else if (error === ApiErrorCode.PASSWORD_RECOVERY_BLOCKED) {
                dispatch(Actions.userLockdown());
              } else {
                dispatch(Actions.checkRecoveryCodeValidityError());
              }
            });
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0); // eslint-disable-line no-console

            dispatch(Actions.checkRecoveryCodeValidityError());
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 9]]);
  }));
  return _handleRecoveryCodeCheckFetch.apply(this, arguments);
}
function handlePasswordSaveFetch(_x5, _x6, _x7, _x8) {
  return _handlePasswordSaveFetch.apply(this, arguments);
}
/**
 * Handle recover by email API call
 * @param {String} apiUrl API url
 * @param {Function} dispatch Store actions handler
 * @param {String} email Client email by which password should be recovered
 * @param {String} token Google Captcha token received on verify
 * @returns {Void} Nothing to return
 */

function _handlePasswordSaveFetch() {
  _handlePasswordSaveFetch = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(apiUrl, token, dispatch, newPassword) {
    var _ref3, res, body;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return API.savePassword(apiUrl, token, newPassword);
          case 3:
            _ref3 = _context2.sent;
            res = _ref3.res;
            body = _ref3.body;
            handleResponse(res, body, function () {
              return dispatch(Actions.savePasswordSuccess());
            }, function () {
              return dispatch(Actions.savePasswordError());
            });
            _context2.next = 13;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0); // eslint-disable-line no-console

            dispatch(Actions.savePasswordError());
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 9]]);
  }));
  return _handlePasswordSaveFetch.apply(this, arguments);
}
function handleEmailRecoverFetch(_x9, _x10, _x11, _x12) {
  return _handleEmailRecoverFetch.apply(this, arguments);
}
/**
 * Handle recover by phone number API call
 * @param {String} apiUrl API url
 * @param {Function} dispatch Store actions handler
 * @param {String} phoneNumber Client phone number by which password should be recovered
 * @param {String} token Google Captcha token received on verify
 * @returns {Void} Nothing to return
 */

function _handleEmailRecoverFetch() {
  _handleEmailRecoverFetch = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(apiUrl, dispatch, email, token) {
    var _ref4, res, body;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return API.recoverPasswordByEmail(apiUrl, email, token);
          case 3:
            _ref4 = _context3.sent;
            res = _ref4.res;
            body = _ref4.body;
            handleResponse(res, body, function (body) {
              var isTryValid = isRecoverTryValid(body);
              if (isTryValid) {
                dispatch(Actions.recoverByEmailSuccess(body.attemptCount, body.token, email));
              } else {
                dispatch(Actions.recoverByEmailError());
              }
            }, function (body) {
              var error = getError(body);
              if (error === ApiErrorCode.CLIENT_NOT_FOUND) {
                dispatch(Actions.recoverByEmailInvalid());
              } else if (error === ApiErrorCode.PASSWORD_RECOVERY_BLOCKED) {
                dispatch(Actions.userLockdown());
              } else {
                dispatch(Actions.recoverByEmailError());
              }
            });
            _context3.next = 13;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0); // eslint-disable-line no-console

            dispatch(Actions.recoverByEmailError());
          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 9]]);
  }));
  return _handleEmailRecoverFetch.apply(this, arguments);
}
function handlePhoneRecoverFetch(_x13, _x14, _x15, _x16) {
  return _handlePhoneRecoverFetch.apply(this, arguments);
}
/**
 * API middleware for redux store.
 * @return {any} Returns next action handle
 */

function _handlePhoneRecoverFetch() {
  _handlePhoneRecoverFetch = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(apiUrl, dispatch, phoneNumber, token) {
    var _ref5, res, body;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return API.recoverPasswordByPhone(apiUrl, phoneNumber, token);
          case 3:
            _ref5 = _context4.sent;
            res = _ref5.res;
            body = _ref5.body;
            handleResponse(res, body, function (body) {
              var isTryValid = isRecoverTryValid(body);
              if (isTryValid) {
                dispatch(Actions.recoverByPhoneSuccess(body.attemptCount, body.token, phoneNumber));
              } else {
                dispatch(Actions.recoverByPhoneError());
              }
            }, function (body) {
              var error = getError(body);
              if (error === ApiErrorCode.CLIENT_NOT_FOUND) {
                dispatch(Actions.recoverByPhoneInvalid());
              } else if (error === ApiErrorCode.PASSWORD_RECOVERY_BLOCKED) {
                dispatch(Actions.userLockdown());
              } else {
                dispatch(Actions.recoverByPhoneError());
              }
            });
            _context4.next = 13;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            console.error(_context4.t0); // eslint-disable-line no-console

            dispatch(Actions.recoverByPhoneError());
          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[0, 9]]);
  }));
  return _handlePhoneRecoverFetch.apply(this, arguments);
}
export default function apiMiddleware() {
  return function (_ref) {
    var dispatch = _ref.dispatch,
      getState = _ref.getState;
    return function (next) {
      return function (action) {
        var state = getState();
        var apiUrl = state.passwordRecover.get('apiUrl');
        var token = state.passwordRecover.get('recoverToken');
        var captchaToken = state.passwordRecover.get('captchaToken');
        switch (action.type) {
          case CHECK_RECOVERY_CODE_VALIDITY_FETCH:
            handleRecoveryCodeCheckFetch(apiUrl, token, dispatch, action.payload.recoveryCode);
            break;
          case SAVE_PASSWORD_FETCH:
            handlePasswordSaveFetch(apiUrl, token, dispatch, action.payload.newPassword);
            break;
          case RECOVER_BY_EMAIL_FETCH:
            handleEmailRecoverFetch(apiUrl, dispatch, action.payload.email, captchaToken);
            break;
          case RECOVER_BY_PHONE_FETCH:
            handlePhoneRecoverFetch(apiUrl, dispatch, action.payload.phoneNumber, captchaToken);
            break;
        }
        return next(action);
      };
    };
  };
}